import React from 'react';
import { withHOCComponent } from '../components/hoc/HOCComponent';
import { withStyles } from '@mui/styles';

import View from '../components/main/View';
import ViewContent from '../components/main/ViewContent';
import { HomeIcon } from '../components/commons/Icons';
import { Box, Button, Typography } from '@mui/material';

class NotFound extends React.Component {

  render () {
    const { classes } = this.props;
    return (
      <View
        headerTitle="Introuvable"
        headerLeft={[{el: "go-back"}]}
        bgImage={true}
        justifyContent={true}
        hideFooter={true}
      >
        <ViewContent displayLogo={true}>
          <Box className={classes.content}>
            <Typography className={classes.text} variant="body1" component="div">Ce chemin ne mène nulle part.</Typography>
            <Button className={classes.button} variant="contained" startIcon={<HomeIcon />} onClick={ () => this.props.hoc.redirectTo('/') }>Accueil</Button>
          </Box>
        </ViewContent>
      </View>
    );
  }
}

const styles = theme => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  text: {
    marginBottom: theme.spacing(3)
  }
});

export default withHOCComponent(withStyles(styles, { withTheme: true })(NotFound));
